import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import CommesseTableRow from './CommesseTableRow'
import TablePager from '../TablePager'
import TableColumnOrdered from '../TableColumnOrdered'
import PropTypes from 'prop-types';
class CommesseTable extends Component {
    constructor(props) {
        super(props);
        let rv = this.updateData(props.count, props.rowperpage);
        this.state = {
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };

        this.onChangePage = this.onChangePage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let rv = this.updateData(nextProps.count, nextProps.rowperpage);
        this.setState(rv);
    }

    updateData(count, rowperpage){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        return {pages, lastPage}
    }

    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }


    render() {
        return (
            <div className="ep-outer-table">
                <div className="ep-inner-scrollable-table">
                    <table className="ui striped sortable celled compact table">
            <thead>
            <tr><th colSpan="15">
                {/*<Link to={`/app/commesse/new`}>*/}
                {/*    <div className="ui left floated small primary labeled icon button">*/}
                {/*        <i className="plus icon"></i> Nuova Commessa*/}
                {/*    </div>*/}
                {/*</Link>*/}
                {/*<PrintButton />*/}

                <a href="#" onClick={(ev) => (this.props.onChangeOrder(''))}>
                    <i className="sort icon"></i> Ripristina ordinamento standard
                </a>

                <TablePager
                    pages={this.state.pages} page={this.props.page}
                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr>
            <tr>
                <TableColumnOrdered
                    name="id"
                    orderActive={this.props.tableOrderingField === "id"}
                    orderFields="idCommessa"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >ID</TableColumnOrdered>
                <th className="no-print"></th>
                <TableColumnOrdered
                    name="codice"
                    orderActive={this.props.tableOrderingField === "codice"}
                    orderFields="codice"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Codice</TableColumnOrdered>
                <TableColumnOrdered
                    name="nome"
                    orderActive={this.props.tableOrderingField === "nome"}
                    orderFields="nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Nome</TableColumnOrdered>
                <TableColumnOrdered
                    name="dataIncarico"
                    orderActive={this.props.tableOrderingField === "dataIncarico"}
                    orderFields="dataIncarico"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Inizio incarico</TableColumnOrdered>
                <TableColumnOrdered
                    name="altreDate"
                    orderActive={this.props.tableOrderingField === "altreDate"}
                    orderFields="dataInizioPrestazione, dataFinePrestazione, dataChiusura"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Altre date</TableColumnOrdered>
                <TableColumnOrdered
                    name="ragioneSociale"
                    orderActive={this.props.tableOrderingField === "ragioneSociale"}
                    orderFields="ragioneSociale"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Cliente</TableColumnOrdered>
                <TableColumnOrdered
                    name="peso"
                    orderActive={this.props.tableOrderingField === "peso"}
                    orderFields="peso"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Peso</TableColumnOrdered>
                <TableColumnOrdered
                    name="incassoPresunto"
                    orderActive={this.props.tableOrderingField === "incassoPresunto"}
                    orderFields="incassoPresunto"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Incasso Presunto</TableColumnOrdered>
                <TableColumnOrdered
                    name="priorita"
                    orderActive={this.props.tableOrderingField === "priorita"}
                    orderFields="priorita,nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Priorità</TableColumnOrdered>
                <TableColumnOrdered
                    name="conclusa"
                    orderActive={this.props.tableOrderingField === "conclusa"}
                    orderFields="conclusa"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Chiusa</TableColumnOrdered>
                <TableColumnOrdered
                    name="archiviata"
                    orderActive={this.props.tableOrderingField === "archiviata"}
                    orderFields="archiviata"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Archiviata</TableColumnOrdered>
                <TableColumnOrdered
                    name="inRendicontazione"
                    orderActive={this.props.tableOrderingField === "inRendicontazione"}
                    orderFields="inRendicontazione"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >In Rendic.</TableColumnOrdered>
                <th className="no-print"></th>
            </tr>
            </thead>
            <tbody>
            {this.props.items.map((commessa) => (
                <CommesseTableRow commessa={commessa} key={commessa.idCommessa} onDeleteItem={this.props.onDeleteItem} readOnly={this.props.readOnly}/>
            ))}
            </tbody>
            <tfoot>
            </tfoot>
        </table>
                </div>
            </div>)
    }
}

CommesseTable.PropTypes = {
    items: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onDeleteItem: PropTypes.func,
    readOnly: PropTypes.bool
}
export default CommesseTable;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseTable.js
 **/